__turbopack_context__.v({
  "articleheader": "ArticleHeader-module-scss-module__HSAFyW__articleheader",
  "pageheadermeta": "ArticleHeader-module-scss-module__HSAFyW__pageheadermeta",
});
